import { useEffect, useState } from 'react';

import { buildEmptyExploration } from '@/core/exploration';

import { Exploration } from '../types';
import { useExplorationStorageContext } from './exploration-storage-context';

const emptyExploration = buildEmptyExploration('Explore');

export const useExploration = (explorationId: string | undefined) => {
  const { getExploration } = useExplorationStorageContext();
  const { setExploration } = useExplorationStorageContext();

  const [currentExploration, setCurrentExploration] = useState<Exploration | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchExploration = async (eId: string) => {
      const exploration = await getExploration(eId);

      if (!cancelled) {
        setLoading(false);
        setCurrentExploration(exploration ?? null);
      }
    };

    if (explorationId === undefined) {
      setLoading(false);
      setCurrentExploration(null);
      return;
    }

    fetchExploration(explorationId);

    return () => {
      cancelled = true;
    };
  }, [explorationId, getExploration]);

  const handleSetExploration = (exploration: Exploration) => {
    exploration = setExploration(exploration);
    setCurrentExploration(exploration);
    return exploration;
  };

  return {
    exploration: currentExploration ?? emptyExploration,
    setExploration: handleSetExploration,
    loading,
  };
};
